import { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from '@heroicons/react/24/solid';

const reviews = [
  {
    id: 1,
    name: 'Dr. Achieng Otieno',
    title: 'Hospital Administrator - Aga Khan Hospital',
    text: 'IPSA’s policy repository has transformed how we manage compliance. Highly recommended!',
    image: '/images/grace.jpeg',
    rating: 5
  },
  {
    id: 2,
    name: 'Dr. Kamau Mwangi',
    title: 'Clinic Officer - PGH Nakuru',
    text: 'The downloadable systems are easy to implement and have improved our workflow.',
    image: '/images/david.jpeg',
    rating: 4
  },
  {
    id: 3,
    name: 'Dr. Amina Ali',
    title: 'Head Surgeon - Nairobi Hospital',
    text: 'Consultation services are top-notch. IPSA is a game-changer for healthcare governance.',
    image: '/images/amina.jpeg',
    rating: 5
  },
  {
    id: 4,
    name: 'Dr. Samuel Ngetich',
    title: 'Head Nurse - Kenyatta Hospital',
    text: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    image: '/images/samuel.jpeg',
    rating: 5
  },
];

const ReviewCard = ({ name, text, image, title, rating }) => (
  <div style={{ borderRadius: "42px" }} className="bg-blue-800  shadow-lg p-6 w-80 flex-shrink-0">
    <div className="flex justify-center mb-4">
      <div className="w-32 h-32 text-center rounded-full bg-blue-200 overflow-hidden">
        <img src={image} alt={name} className="w-full h-full object-cover" />
      </div>
    </div>
    <p className="text-center text-green-200 text-2xl font-semibold">{name}</p>
    <small className="text-center text-green-400 text-1xl font-semibold block">{title}</small>
    <div className="flex justify-center mt-4">
      {[...Array(5)].map((_, i) => (
        <StarIcon
          key={i}
          className={`h-8 w-8 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        />
      ))}
    </div>
    <p className="text-sm text-gray-100 font-semibold text-center mb-2 mt-4">{text}</p>
  </div>
);

export default function UserReviewComponent() {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -380, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 380, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused && scrollRef.current) {
        scrollRef.current.scrollBy({ left: 380, behavior: 'smooth' });
      }
    }, 4000); // scroll every 4 seconds

    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <section className="bg-gray-100 py-12 px-4">
      <div className="max-w-5xl mx-auto text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-800">TESTIMONIALS</h2>
        <p className="text-gray-600">What Our Clients Say</p>
      </div>

      <div
        className="relative flex items-center justify-center"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <button
          onClick={scrollLeft}
          className="absolute left-0 z-10 bg-white p-2 rounded-full shadow hover:bg-green-100"
        >
          <ChevronLeftIcon className="h-6 w-6 text-green-600" />
        </button>

        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto px-10 scroll-smooth scrollbar-hide"
        >
          {reviews.map((review) => (
            <ReviewCard key={review.id} {...review} />
          ))}
        </div>

        <button
          onClick={scrollRight}
          className="absolute right-0 z-10 bg-white p-2 rounded-full shadow hover:bg-green-100"
        >
          <ChevronRightIcon className="h-6 w-6 text-green-600" />
        </button>
      </div>
    </section>
  );
}
